const buttonStyles = {
  fontSize: "inherit",
  fontFamily: "Poppins",
  textTransform: "capitalize",
  borderRadius: 12,
};

export default buttonStyles;
